import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Header } from "../design-system";
import routes from "../router/config";

export const SiteHeader = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const links = routes
    .filter((r) => r.nav)
    .map((r) => ({
      label: r.label as string,
      href: r.path,
      onClick: (e: React.MouseEvent) => {
        e.preventDefault();
        navigate(r.path);
      },
    }));

  return <Header links={links} current={pathname} logoBase="/img/logo" />;
};
